<template>
  <div>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder" class="flex-1 form-input block w-full min-w-0 rounded transition duration-150 ease-in-out sm:leading-5" :class="hasErrorClasses" />
      <div v-if="error" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
        </svg>
      </div>
    </div>
    <p v-if="error && errorText !== ''" class="mt-1 text-sm text-red-600" id="email-error">Your password must be less than 4 characters.
  </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorText: {
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasErrorClasses(){


      return {
        "border-red-300": this.error, 
        "text-red-900": this.error, 
        "placeholder-red-300" : this.error,
        "focus:border-red-300": this.error,
        "focus:shadow-outline-red": this.error,
      }

    },
  },
}
</script>